import { useMemo, useState } from "react";

import { RoomStockDiffStore } from "./room-stock-diff-store";
import { useUpdateRoomStock } from "../../repository/mutation/use-update-room-stock";

import type { ServerModel } from "./type";

type Props = {
	serverModel: ServerModel;
};

export const useCreateRoomStockFormModel = ({ serverModel }: Props) => {
	const [isValid, setIsValid] = useState(false);
	const [isDirty, setIsDirty] = useState(false);

	const roomStockDiffStore = useMemo(
		() => new RoomStockDiffStore(serverModel.roomStock.items, setIsValid, setIsDirty),
		[serverModel.roomStock.items],
	);

	const onReInitialize = () => {
		setIsValid(false);
		setIsDirty(false);
		roomStockDiffStore.clear();
	};

	const { onUpdateRoomStock } = useUpdateRoomStock({
		onReInitialize,
		serverModel,
		roomStockDiffStore,
	});

	return {
		isDirty,
		isValid,
		onUpdateRoomStock,
		onReInitialize,
		roomStockDiffStore,
	};
};
